import { render, staticRenderFns } from "./LeaderboardUser.vue?vue&type=template&id=0c12a410&scoped=true&"
import script from "./LeaderboardUser.vue?vue&type=script&lang=js&"
export * from "./LeaderboardUser.vue?vue&type=script&lang=js&"
import style0 from "./LeaderboardUser.vue?vue&type=style&index=0&id=0c12a410&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c12a410",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VIcon,VSimpleTable,VTooltip})
